/* Native disclosures remain usable before JavaScript loads. */
if (!customElements.get('premiom-animal-menu')) {
  /* Diagnostic trace for the intermittent "hover no longer opens" bug:
     run premiomMenuDebug() in the console when it happens. */
  const trace = [];
  const log = (...entry) => {
    trace.push([Math.round(performance.now()), ...entry].join(' '));
    if (trace.length > 80) trace.shift();
  };
  window.premiomMenuDebug = () => {
    const menu = document.querySelector('premiom-animal-menu[data-mode="desktop"]');
    const sticky = document.getElementById('sticky-header');
    return {
      connected: menu?.isConnected,
      upgraded: !!menu?.abort,
      aborted: menu?.abort?.signal.aborted,
      instances: document.querySelectorAll('premiom-animal-menu').length,
      scrollY: Math.round(scrollY),
      stickyClasses: sticky?.className.split(' ').filter(c => !c.includes('[')).join(' '),
      activeElement: document.activeElement?.outerHTML.slice(0, 120),
      triggers: [...(menu?.querySelectorAll('details') || [])].map(item => {
        const rect = item.querySelector('summary').getBoundingClientRect();
        const hit = document.elementFromPoint(rect.x + rect.width / 2, rect.y + rect.height / 2);
        return {
          open: item.open,
          hitTestOk: item.contains(hit),
          hit: hit && item.contains(hit) ? null : hit?.outerHTML.slice(0, 120),
          panelDisplay: getComputedStyle(item.querySelector('.premiom-nav__panel')).display,
        };
      }),
      trace: trace.slice(),
    };
  };

  customElements.define('premiom-animal-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.items = [...this.querySelectorAll('details')];
      this.desktop = this.dataset.mode === 'desktop';
      this.header = this.closest('#sticky-header-content');
      const mode = this.dataset.mode;
      log(mode, 'connected', `items=${this.items.length}`, `header=${!!this.header}`);
      const cancel = () => clearTimeout(this.timer);
      const close = reason => {
        cancel();
        if (this.items.some(item => item.open)) log(mode, 'close', reason);
        this.items.forEach(item => { item.open = false; });
      };
      const open = item => {
        cancel();
        log(mode, 'open', this.items.indexOf(item));
        this.items.forEach(other => { other.open = other === item; });
      };
      this.items.forEach((item, index) => {
        const trigger = item.querySelector('summary');
        // Entrée « split » : le lien de l'animal est à côté du <details> (hors summary).
        // Le survol et la flèche bas partent de ce lien ; le summary reste le bouton.
        const link = item.parentElement.querySelector(':scope > .premiom-nav__link');
        const hoverTargets = link ? [trigger, link] : [trigger];
        item.addEventListener('toggle', () => {
          log(mode, 'toggle', index, item.open);
          trigger.setAttribute('aria-expanded', String(item.open));
          if (item.open) this.items.forEach(other => { if (other !== item) other.open = false; });
          this.header?.classList.toggle('premiom-menu-open', this.items.some(other => other.open));
        }, options);
        trigger.setAttribute('aria-expanded', String(item.open));
        trigger.addEventListener('click', cancel, options);
        hoverTargets.forEach(target => {
          target.addEventListener('pointerenter', event => {
            log(mode, 'enter', index, event.pointerType);
            if (!this.desktop || event.pointerType !== 'mouse') return;
            cancel();
            this.timer = setTimeout(() => open(item), 140);
          }, options);
          target.addEventListener('pointerleave', cancel, options);
          target.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              open(item);
              item.querySelector('.premiom-nav__panel a')?.focus();
            }
          }, options);
        });
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const active = this.items.find(item => item.open);
        if (!active) return;
        event.preventDefault();
        event.stopPropagation();
        close('escape');
        (active.parentElement.querySelector(':scope > .premiom-nav__link') || active.querySelector('summary')).focus();
      }, options);
      // Safari/iOS ne donne pas le focus au lien touché : relatedTarget est null et refermer
      // ici masquerait le lien avant le clic. Le clic hors du menu est géré par pointerdown.
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close('focusout');
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) close('pointerdown-outside');
      }, options);
      if (this.desktop && this.header) {
        this.header.addEventListener('pointerleave', () => {
          cancel();
          this.timer = setTimeout(() => {
            if (!this.contains(document.activeElement)) close('header-leave');
          }, 220);
        }, options);
        this.header.addEventListener('pointerenter', cancel, options);
        this.querySelectorAll('.premiom-nav__item:not(.premiom-nav__item--split) > a').forEach(link => {
          link.addEventListener('pointerenter', () => close('plain-link-enter'), options);
        });
        // Ne réagir qu'au passage à header-up : en haut de page, theme.js réécrit la classe de
        // #sticky-header à chaque image, et refermer à chaque écriture annulerait le survol.
        const sticky = this.header.closest('#sticky-header');
        let headerUp = sticky?.classList.contains('header-up');
        this.stickyObserver = new MutationObserver(() => {
          const up = sticky.classList.contains('header-up');
          if (up && !headerUp) close('sticky-header-up');
          headerUp = up;
        });
        if (sticky) this.stickyObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('resize', () => close('resize'), options);
    }
    disconnectedCallback() {
      log(this.dataset.mode, 'disconnected');
      clearTimeout(this.timer);
      this.abort?.abort();
      this.stickyObserver?.disconnect();
      this.header?.classList.remove('premiom-menu-open');
    }
  });
}
